const errortrans = {
  defaultLang: "english",
  defaultDir: "ltr",
  defaultColor: "#596CFF",
  //Login Page
  signIn: {
    english: "Sign In",
    persian: "ورود",
  },
  forgetPassword: {
    english: "Forget Password?",
    persian: "فراموشی رمز عبور؟",
  },
  remember: {
    english: "Remember",
    persian: "یادآوری",
  },
  email: {
    english: "Email",
    persian: "آدرس ایمیل",
  },
  username: {
    english: "Username",
    persian: "نام کاربری",
  },
  transactions: {
    english: "Transactions",
    persian: "تراکنش ها",
  },
  password: {
    english: "Password",
    persian: "رمز عبور",
  },
  rememberMe: {
    english: "Remember me",
    persian: "مرا به خاطر بسپار",
  },
  logOut: {
    english: "Log Out",
    persian: "خروج",
  },

  /*Header Footer */
  typeHere: {
    english: "Type here...",
    persian: "تایپ کنید...",
  },
  support: {
    english: "SUPPORT",
    persian: "پشتیبانی",
  },
  //CRM Control
  crms: {
    english: "CRM",
    persian: "مدیریت رویدادها",
  },
  crm: {
    english: "crm",
    persian: "افزودن",
  },
  crmName: {
    english: "CRM Name",
    persian: "نام CRM",
  },
  crmCode: {
    english: "CRM Code",
    persian: "کد CRM",
  },
  createdBy: {
    english: "Created By",
    persian: "ایجاد کننده",
  },
  createdOn: {
    english: "Created On",
    persian: "تاریج ایجاد",
  },
  back: {
    english: "Back",
    persian: "عقب",
  },
  setting: {
    english: "Setting",
    persian: "تنظیمات",
  }, //Access Control
  SaleSetting: {
    english: "Sales Setting",
    persian: "پارامترهای فروش",
  },
  SaleParameter: {
    english: "Parameter",
    persian: "نام پارامتر ",
  },
  Amount: {
    english: "Amount",
    persian: "مقدار",
  },
  profiles: {
    english: "Profiles",
    persian: "پروفایل ها",
  },
  profile: {
    english: "Profile",
    persian: "پروفایل",
  },
  profileName: {
    english: "Profile Name",
    persian: "نام پروفایل",
  },
  profileCode: {
    english: "Profile Code",
    persian: "کد پروفایل",
  },
  createdBy: {
    english: "Created By",
    persian: "ایجاد کننده",
  },
  createdOn: {
    english: "Created On",
    persian: "تاریج ایجاد",
  },
  read: {
    english: "Read",
    persian: "خواندن",
  },
  edit: {
    english: "Edit",
    persian: "ویرایش",
  },
  save: {
    english: "save",
    persian: "ذخیره",
  },
  cancel: {
    english: "cancel",
    persian: "انصراف",
  },
  full: {
    english: "Full",
    persian: "کامل",
  },
  newClass: {
    english: "New Class",
    persian: "کلاس جدید",
  },
  setting: {
    english: "Setting",
    persian: "تنظیمات",
  },
  /*Titles*/
  pages: {
    english: "Pages",
    persian: "صفحات",
  },
  orders: {
    english: "Orders",
    persian: "سفارشات",
  },
  shemsh: {
    english: "Shemsh",
    persian: "شمش",
  },
  filterName: {
    english: "Filter Name",
    persian: "نام فیلتر",
  },
  filterCode: {
    english: "Filter Code",
    persian: "کد فیلتر",
  },
};
export default errortrans;
